import { render, staticRenderFns } from "./ProteamDetail.vue?vue&type=template&id=1ffa9e48&scoped=true"
import script from "./ProteamDetail.vue?vue&type=script&lang=js"
export * from "./ProteamDetail.vue?vue&type=script&lang=js"
import style0 from "./ProteamDetail.vue?vue&type=style&index=0&id=1ffa9e48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffa9e48",
  null
  
)

export default component.exports